import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { fetchTransactionAccount } from '@css-xp/billing-v2';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';

export const useFetchTransactionAccountQuery = ({ txaId, skip = false }: { txaId: string; skip?: boolean }) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);
  return usePersistedCacheQuery<
    generatedTypesNew.FetchTransactionAccountV2Query,
    generatedTypesNew.FetchTransactionAccountV2QueryVariables
  >(fetchTransactionAccount, {
    variables: { id: txaId ?? '' },
    skip: skip || !txaId,
    client: ansClient,
  });
};
